import { Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import BrandedLoader from '../../../components/BrandedLoader/BrandedLoader';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
	borderColor,
	buttonStyles,
	button_Styles1,
	csvStyle,
	filterSectionStyle,
	grid_Button_Style,
	grid_Icon_Style,
	headerSection,
	pdfStyle,
	textStyling,
	titleWithTextfield,
	headerStyling,
	reportExcelButtonSx,
	reportFilterFieldSx,
	reportFilterLabelSx,
	reportFilterPanelSx,
	reportMenuProps,
	reportPdfButtonSx,
	reportResetButtonSx,
} from './GeneralStyles';

import {
	getChargesReport,
	getVisit,
	getPracticeStaff,
	getAlllocations,
	getLocation,
	postVisitDatalist,
} from '../../../../app/services/api/apiManager';
import PatientReport from '../PatientReport';
import ReportResultsGrid from '../ReportResultsGrid';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

// Dispatch Section
// import { useStateValue } from '../../../services/state/State';
// import { actions } from '../../../services/state/Reducer';

const AR = () => {
	// const [
	// 	{ practice, practicestats, batches, locations, visits, providers },
	// 	dispatch,
	// ] = useStateValue();

	// const showPracticeData = async () => {
	// 	const response = await getPracticeStaff();
	// 	if (response?.status === 200) {
	// 		dispatch({ type: actions.SET_PROVIDERS, payload: response?.data });
	// 	} else dispatch({ type: actions.SET_PROVIDERS, payload: [] });
	// };

	// Get Practice ID with Local Storage
	const practiceID = localStorage.getItem('practice_id');

	// All Api Data State
	const [allLocations, setAllLocations] = useState([]);
	const [allProviders, setAllProviders] = useState([]);
	const [allVisits, setAllVisits] = useState([]);

	// Filter Data
	const [filterData, setFilterData] = useState([]);

	// Loader State
	const [isLoading, setIsLoading] = useState(true);
	const [gridLoading, setGridLoading] = useState(false);

	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);
	// All Api Data State
	// const [apiData, setApiData] = useState([]);

	// Export Data State
	const [exportData, setExportData] = useState(true);

	const [pdfUrl, setPdfUrl] = useState('');

	// Handle Date Value States
	const [dateValue, setDateValue] = useState({
		fromDate: dayjs().startOf('month'),
		toDate: dayjs(),
	});

	// Formate date
	const formatFromDate = dayjs(dateValue.fromDate).format('YYYY-MM-DD');
	const formatToDate = dayjs(dateValue.toDate).format('YYYY-MM-DD');

	// Target Date Value Function
	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
		getVisitListData(filterData);
	};

	// Handle Select Value States
	const [selectValue, setSelectValue] = useState({
		location: '',
		provider: '',
	});

	// Target Select Value Function
	const handleSelectValue = (event) => {
		setSelectValue({
			...selectValue,
			[event.target.name]: event.target.value,
		});
		getVisitListData(filterData);
	};

	// Reset All Values
	const resetValues = () => {
		setSelectValue({
			location: '',
			provider: '',
		});
		setDateValue({
			fromDate: '',
			toDate: '',
		});

		setExportData(true);
		setFilterData([]);
		getVisitListData({ practice_id: practiceID, in_VisitStatus: 'D' }); // get all Data, after Resting Textfields
	};

	// Define table styles
	const styles = {
		cellPadding: 2,
		fontSize: 12,
		halign: 'center',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
	};

	// Download Pdf File with All Data

	const downloadAllData = () => {
		// const draftedStatus = allVisits?.filter((item) => {
		// 	return item?.VisitStatus == 'D';
		// });

		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Draft Visit History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Draft Visit History', xPos, 15);

		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');

		doc.autoTable({
			startY: 20,
			head: [
				[
					// Colmn Fields Name here
					'Serial No.',
					'Patient',
					'Gender',
					'Provider',
					'Location',
					'Visit Status',
					'Visit Date',
				],
			],
			body: allVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ', ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.provider === ', ' ? '' : item?.provider,
				,
				item?.location != null || item?.location != '' ? item?.location : '',
				item?.VisitStatus == 'D' ? 'Drafted' : '',
				dayjs(item?.VisitDate).format('DD-MM-YYYY'),
			]),
			styles: styles,

			// Add Styling
			//     columnStyles: {
			//       fillColor: "cyan",
			//   0: { textAlign: 'center', fillColor: 'cyan', }, // ID column
			//   1: { textAlign: 'center', fillColor: 'cyan' }, // Patient Name column
			//   2: { textAlign: 'center', fillColor: 'cyan' }, // Doctor Name column
			//   3: { textAlign: 'center', fillColor: 'cyan' }, // Appointment Status column
			//   4: { align: 'center', fillColor: 'cyan', }, // Patient Contact column
			//   5: { textAlign: 'center', fillColor: 'cyan' }, // Appointment Date column
			// },
		});

		// doc.addPage();

		doc.save('Draft Visit Report.pdf');

		// Save PDF as blob
		// const blob = doc.output("blob");

		// Create blob URL
		// const url = URL.createObjectURL(blob);
		// setPdfUrl(url);
	};

	// Function - Download PDF File with Filter Data
	const downloadFilterData = () => {
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('Draft Visit History') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('Draft Visit History', xPos, 15);

		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');
		doc.autoTable({
			startY: 20,
			head: [
				[
					// Colmn Fields Name here
					'Serial No.',
					'Patient',
					'Gender',
					'Provider',
					'Location',
					'Visit Status',
					'Visit Date',
				],
			],

			body: allVisits?.map((item, index) => [
				index + 1,
				item?.patient?.Lname + ', ' + item?.patient?.Fname,
				item?.Gender == 'M'
					? 'Male'
					: item?.Gender == 'F'
						? 'Female'
						: item?.Gender == 'o' || item?.Gender == 'O'
							? 'Other'
							: '',
				item?.provider === ', ' ? '' : item?.provider,
				item?.location != null || item?.location != '' ? item?.location : '',
				item?.VisitStatus == 'D' ? 'Drafted' : '',
				dayjs(item?.VisitDate).format('DD-MM-YYYY'),
			]),
			styles: styles,
		});

		// doc.addPage();

		doc.save('Draft Visit Report.pdf');
		setFilterData(allVisits);

		// Save PDF as blob
		// const blob = doc.output("blob");

		// Create blob URL
		// const url = URL.createObjectURL(blob);
		// setPdfUrl(url);
	};

	// Function - Download CSV File with All Data

	const downloadAllCSV = () => {
		// const approvedStatus = allVisits.filter((item) => {
		// 	return item.VisitStatus == 'D';
		// });

		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'Gender',
				'Provider',
				'Location',
				'Visit Status',
				'Visit Date',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ', ' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'o' || row?.Gender == 'O'
									? 'Other'
									: '',
						row?.provider === ', ' ? '' : row?.provider,
						row?.location != null || row?.location != '' ? row?.location : '',
						row?.VisitStatus == 'D' ? 'Drafted' : '',
						dayjs(row?.VisitDate).format('DD-MM-YYYY'),
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Draft Visit Report.xlsx');
	};

	// Function - Download CSV File with Filter Data

	const downloadFilterCSV = () => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'Gender',
				'Provider',
				'Location',
				'Visit Status',
				'Visit Date',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		allVisits?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.patient?.Lname + ', ' + row?.patient?.Fname,
						row?.Gender == 'M'
							? 'Male'
							: row?.Gender == 'F'
								? 'Female'
								: row?.Gender == 'o' || row?.Gender == 'O'
									? 'Other'
									: '',
						row?.provider === ', ' ? '' : row?.provider,
						row?.location != null || row?.location != '' ? row?.location : '',
						row?.VisitStatus == 'D' ? 'Drafted' : '',
						dayjs(row?.VisitDate).format('DD-MM-YYYY'),
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Draft Visit Report.xlsx');
	};

	// Function -- Download PDF Data

	const handleDownloadPdf = async () => {
		if (
			selectValue.location ||
			selectValue.provider ||
			dateValue.fromDate ||
			dateValue.toDate
		) {
			downloadFilterData(); // Direct Call throug Api Filtering in.
		} else {
			downloadAllData(); // All Data in PDF
		}
	};

	// Function -- Download CSV Data

	const handleDownloadCSV = () => {
		if (
			selectValue.location ||
			selectValue.provider ||
			dateValue.fromDate ||
			dateValue.toDate
		) {
			downloadFilterCSV(); // Filter CSV
		} else {
			downloadAllCSV(); // All Data
		}
	};

	// Function For Getting API Locations Data

	const fetchLocations = async () => {
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setAllLocations(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Locations:', error);
		}
	};

	// Function For Getting API Provider Data

	const getProviders = async () => {
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setAllProviders(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Provider:', error);
		}
	};

	// Function For Getting API Visits Data
	// const getVisits = async () => {
	// 	try {
	// 		// const response = await getChargesReport();
	// 		const response = await getVisit();
	// 		if (response?.status === 200) {
	// 			setAllVisits(response?.data);
	// 			// console.log('Visits Data: ', response?.data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching Visits:', error);
	// 	}
	// };

	//shahid  zaman function from chargelist
	const getVisitListData = async (data) => {
		setGridLoading(true);
		try {
			// setLoading(true);
			const response = await postVisitDatalist(data);
			if (response?.status === 200 || response?.status === 201) {
				setAllVisits(response?.data);
				// console.log('vidit data zaman', response?.data);
			} else {
				// setVisitDataList([]);
			}
			// setLoading(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			// setLoading(false);
		} finally {
			setGridLoading(false);
		}
	};

	// get data Through Post method
	const filtersData = {
		practice_id: practiceID,
		in_VisitStatus: 'D',
		...(formatFromDate !== 'Invalid Date' && { in_DateFrom: formatFromDate }),
		...(formatToDate !== 'Invalid Date' && { in_DateTo: formatToDate }),
		...(selectValue.location && { in_Location: selectValue.location }),
		...(selectValue.provider && { in_Provider: selectValue.provider }),
	};

	// console.log('Filter Out Data => ', allVisits);

	// Fetching Api Data
	useEffect(() => {
		// getData();
		// showPracticeData();

		// if (locations?.length > 0 && visits?.length > 0 && providers?.length > 0) {
		// 	setIsLoading(false);
		// }

		const fetchData = async () => {
			try {
				await fetchLocations();
				await getProviders();
				// await getVisits();
				await getVisitListData(filtersData);

				// Check if all data arrays are not empty
				if (allLocations && allProviders && allVisits) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [selectValue, dateValue]);

	useEffect(() => {
		const hasFilters =
			dateValue.fromDate ||
			dateValue.toDate ||
			selectValue.location ||
			selectValue.provider;
		setFilterData(hasFilters ? allVisits || [] : []);
	}, [allVisits, dateValue, selectValue]);

	const draftVisitGridRows = filterData?.map((row) => ({
		Patient: `${row?.patient?.Lname || ''}, ${row?.patient?.Fname || ''}`.trim(),
		Gender:
			row?.Gender == 'M'
				? 'Male'
				: row?.Gender == 'F'
					? 'Female'
					: row?.Gender == 'o' || row?.Gender == 'O'
						? 'Other'
						: '',
		Provider: row?.provider === ', ' ? '' : row?.provider,
		Location: row?.location != null || row?.location != '' ? row?.location : '',
		'Visit Status': row?.VisitStatus == 'D' ? 'Draft' : '',
		'Visit Date': dayjs(row?.VisitDate).format('DD-MM-YYYY'),
	}));

	return currentPage ? (
		isLoading ? (
			<BrandedLoader title="Loading report" text="Preparing report data" />
		) : (
			<Paper
				elevation={1}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
					}}
				>
					<Box
						style={headerStyling}
						sx={{
							padding: {
								xl: '0.7rem',
								lg: '0.7rem',
								md: '0.7rem',
								sm: '0.5rem',
								xs: '0.3rem',
							},
						}}
					>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography
							style={headerSection}
							sx={{
								fontSize: {
									xl: '20px',
									lg: '20px',
									md: '16px',
									sm: '12px',
									xs: '12px',
								},
							}}
						>
							{' '}
							Draft Visit History
						</Typography>
					</Box>
					<Box sx={reportFilterPanelSx}>
						<Grid container spacing={2} alignItems="flex-end">
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>From Date</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										value={dateValue?.fromDate}
										name="fromDate"
										onChange={(event) => handleDateValue('fromDate', event)}
										slotProps={{
											textField: {
												size: 'small',
												fullWidth: true,
												placeholder: 'MM/DD/YYYY',
												sx: reportFilterFieldSx,
											},
										}}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>To Date</Typography>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										value={dateValue?.toDate}
										name="toDate"
										onChange={(event) => handleDateValue('toDate', event)}
										slotProps={{
											textField: {
												size: 'small',
												fullWidth: true,
												placeholder: 'MM/DD/YYYY',
												sx: reportFilterFieldSx,
											},
										}}
									/>
								</LocalizationProvider>
							</Grid>
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>Location</Typography>
								<FormControl fullWidth size="small" sx={reportFilterFieldSx}>
									<Select
										displayEmpty
										value={selectValue.location}
										name="location"
										onChange={(event) => handleSelectValue(event)}
										MenuProps={reportMenuProps}
										renderValue={(selected) =>
											selected
												? allLocations?.find((item) => item?.id === selected)
														?.Name
												: 'Select Location'
										}
									>
										<MenuItem value={''}>Clear Filter</MenuItem>
										{allLocations?.map((items, index) => (
											<MenuItem value={items?.id} key={index}>
												{items?.Name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xl={2.2} lg={2.3} md={3} sm={6} xs={12}>
								<Typography sx={reportFilterLabelSx}>Provider</Typography>
								<FormControl fullWidth size="small" sx={reportFilterFieldSx}>
									<Select
										displayEmpty
										name="provider"
										value={selectValue.provider}
										onChange={(event) => handleSelectValue(event)}
										MenuProps={reportMenuProps}
										renderValue={(selected) =>
											selected
												? allProviders?.find((item) => item?.id === selected)
														?.Lname +
													', ' +
													allProviders?.find((item) => item?.id === selected)
														?.Fname
												: 'Select Provider'
										}
									>
										<MenuItem value={''}>Clear Filter</MenuItem>
										{allProviders?.map((item, index) => (
											<MenuItem key={index} value={item?.id}>
												{item?.Lname + ', ' + item?.Fname}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xl={3.2} lg={2.8} md={12} sm={6} xs={12}>
								<Box
									sx={{
										display: 'flex',
										justifyContent: { lg: 'flex-end', xs: 'flex-start' },
										gap: 1,
										flexWrap: 'wrap',
									}}
								>
									<Button
										variant="contained"
										sx={reportResetButtonSx}
										disabled={
											!(
												dateValue.fromDate ||
												dateValue.toDate ||
												selectValue.location ||
												selectValue.provider
											)
										}
										onClick={() => resetValues()}
									>
										Reset
									</Button>
									<Button
										variant="outlined"
										sx={reportExcelButtonSx}
										onClick={() => handleDownloadCSV()}
										startIcon={
											<Box component="img" src={xlsx} alt="" sx={{ width: 16, height: 16 }} />
										}
									>
										Excel
									</Button>
									<Button
										variant="outlined"
										sx={reportPdfButtonSx}
										onClick={() => handleDownloadPdf()}
										startIcon={
											<Box component="img" src={pdf} alt="" sx={{ width: 16, height: 16 }} />
										}
									>
										PDF
									</Button>
								</Box>
							</Grid>
						</Grid>
					</Box>
				</Box>
				<Divider />
				<Box
					style={filterSectionStyle}
				>
					<ReportResultsGrid rows={draftVisitGridRows} loading={gridLoading} />
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default AR;
